<template>
  <b-modal
      id="record-catch-lightbox-modal"
      ref="record-catch-lightbox-modal"
      hide-footer
      centered
      size="lg"
      title="Kép megtekintése"
  >
      <img class="img-fluid" :src="imageUrl" alt="" title="" />
  </b-modal>
</template>

<script>

import { BOverlay } from 'bootstrap-vue';

export default {
  props: {
    imageUrl: {
      required: true
    }
  },
  components: {
    BOverlay
  },
}
</script>
